export const MENU_ID_TABLE_CONTEXT_MENU = 'CONTEXT_MENU'

export const MENU_ID_TREE_DEVICE_MENU = 'DEVICE_TREE_MENU';

export const MENU_ID_TREE_GROUP_MENU = 'GROUP_TREE_MENU';

export const getMenuId = (id?: string) => `${ MENU_ID_TABLE_CONTEXT_MENU }${ id ? `_${ id }` : '' }`;

export const getTreeNodeMenuId = (id?: string, isDevice = false) => `${ isDevice ? MENU_ID_TREE_DEVICE_MENU : MENU_ID_TREE_GROUP_MENU }${ id ? `_${ id }` : '' }`;
